import { memo } from 'react';

import { MenuItem, Text } from '@/components/core';
import { CSVIcon, JSONIcon } from '@/components/icons';
import { useCreateCSVExport, useCreateJSONExport, useDownloadFile } from '@/hooks';

export type ExportMenuItemsProps = {
  agentId?: string | null;
  runIds?: string[] | null;
};

const IExportMenuItems = ({ agentId, runIds }: ExportMenuItemsProps) => {
  const { create: createCSV } = useCreateCSVExport({ agentId, runIds });
  const { create: createJSON } = useCreateJSONExport({ agentId, runIds });
  const { download: downloadCSV } = useDownloadFile({ fetchData: createCSV, downloadedFileName: 'export.csv' });
  const { download: downloadJSON } = useDownloadFile({ fetchData: createJSON, downloadedFileName: 'export.json' });

  return (
    <>
      <MenuItem onAction={downloadCSV}>
        <CSVIcon />
        <Text>Export as CSV</Text>
      </MenuItem>
      <MenuItem onAction={downloadJSON}>
        <JSONIcon />
        <Text>Export as JSON</Text>
      </MenuItem>
    </>
  );
};

export const ExportMenuItems = memo(IExportMenuItems) as typeof IExportMenuItems;
